// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';
import {twMerge} from 'tailwind-merge';

import {ClearSettingsRow} from '../components/ClearSettingsRow';
import {useMediaSettingsDrawerContext} from './MediaSettingsDrawerContextProvider';
import {MediaSettingsSection, SettingsLevel} from './types';

export const MediaSettingsDrawerSection = ({
  title,
  settings,
}: MediaSettingsSection) => {
  const [isOpen, setIsOpen] = useState(true);
  const {config, numberOfOverridesBelow, clearOverridesBelow} =
    useMediaSettingsDrawerContext();
  return (
    <>
      <div className="mt-0 flex flex-col first:mt-4">
        <div
          className="my-12 flex h-32 cursor-pointer items-center justify-between text-moon-500 hover:text-moon-650 dark:hover:text-moon-350"
          onClick={() => setIsOpen(!isOpen)}>
          <div className="text-[15px] font-semibold uppercase tracking-wide">
            {title}
          </div>
          <Button
            data-test={`media-settings-drawer-section-toggle-${title}`}
            icon={isOpen ? 'chevron-up' : 'chevron-down'}
            variant="ghost"
            size="small"
          />
        </div>
        {isOpen && (
          <div data-test={`media-settings-drawer-section-${title}`}>
            {settings.map(
              (
                {component: SettingComponent, getComponentKey, configKey},
                index
              ) => (
                <div
                  key={`${title}-${index}-${getComponentKey?.(config) ?? ''}`}
                  className="flex flex-col gap-8 pt-16 first:pt-0">
                  <SettingComponent />
                  {config[configKey] != null &&
                    Object.keys(numberOfOverridesBelow ?? {}).map(level => {
                      const levelKey = level as SettingsLevel; // We know that the keys are all SettingsLevel values
                      if (
                        numberOfOverridesBelow?.[levelKey]?.[configKey] ===
                        undefined
                      ) {
                        return null;
                      }
                      return (
                        <ClearSettingsRow
                          key={levelKey}
                          settingLevel={levelKey}
                          count={
                            numberOfOverridesBelow?.[levelKey]?.[configKey]
                          }
                          clearSetting={() =>
                            clearOverridesBelow?.[levelKey]?.(configKey)
                          }
                          settingKey={configKey}
                        />
                      );
                    })}
                </div>
              )
            )}
          </div>
        )}
      </div>
      <div
        role="separator"
        className={twMerge('h-px bg-moon-250', isOpen && 'mt-16')}
      />
    </>
  );
};
